import { render, staticRenderFns } from "./DashboardProjectList.vue?vue&type=template&id=5e65d427&"
import script from "./DashboardProjectList.vue?vue&type=script&lang=ts&"
export * from "./DashboardProjectList.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardProjectList.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports